<template>
  <div class="order-list" :style="{'background-color':bgColor }" @click="toSearchItem">
    <van-image class="order-item-img" :src="(filePrefix + detailItem.itemImageUri)"
      :style="{'width': height,'height': height}"></van-image>
    <div class="order-item-content" :style="{'min-height': height}">
      <div class="row">
        <p class="color-green van-multi-ellipsis--l2"><span>礼品名称：</span>{{ detailItem.itemName }}</p>
        <div class="color-green ">x{{ detailItem.itemQuantity }}</div>
      </div>
      <div>
        <div class="row" v-if="orderInfo">
          <p class="from-group"><span v-if="detailItem.fromGroupName"> 所属礼品组：{{detailItem.fromGroupName}}</span></p>
        </div>
         <div class="text-right margin-y-2">
          <van-button class="button-import" type="primary" size="mini" round v-if="isElearningCourse || detailItem.itemCategoryCode === '501'" @click.stop="openElearning()">打开课程</van-button>

         </div>
        <div class="row flex-end">
          <p class="point-red">{{ detailItem.pointTypeName }}：<span>{{ detailItem.pointValue }}</span></p>
          <div class="text-right point-red cancel-order"
            v-if="detailItem.returnStatus === 0 && orderInfo.baseInfo.orderStatus === '10' && (detailItem.detailPoint[0] && detailItem.detailPoint[0].isSpecial === 0) && !orderInfo.couponInfo && !detailItem.fromGroupName"
            @click.stop="orderCancel()">取消订购</div>
          <div class="col-33 text-right point-red"
            v-if="detailItem.returnStatus === 0 && orderInfo.baseInfo.orderStatus === '10' && (detailItem.detailPoint[0] &&  detailItem.detailPoint[0].isSpecial) === 1">
            待发货</div>
          <div class="col-33 text-right point-red"
            v-if="detailItem.returnStatus === 0 && orderInfo.baseInfo.orderStatus === '20'">客服已确认</div>
          <div class="col-33 text-right point-red"
            v-if="detailItem.returnStatus === 0 && (orderInfo.baseInfo.orderStatus === '20' || orderInfo.baseInfo.orderStatus === '30')">
            已发货</div>

          <div class="col-33 text-right point-red"
            v-if="detailItem.returnStatus === 0 && orderInfo.baseInfo.orderStatus === '50'">已完成</div>
          <div class="col-33 text-right point-red" v-if="detailItem.returnStatus === 1">已取消</div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { commonUtils } from '@/utils/common'
export default {
  props: {
    detailItem: {
      type: Object,
      default: () => { }
    },
    orderInfo: {
      type: Object,
      default: () => { }
    },
    isElearningCourse: {
      type: Boolean,
      default: false
    },
    height: {
      type: String,
      default: '2.8rem'
    },
    bgColor: {
      type: String,
      default: '#f1f1f1'
    }
  },
  components: {},
  data () {
    return {}
  },

  computed: {
    ...mapState({
      filePrefix: state => state.base.ApiEndpoint.fileUrl
    }),
    // 判断是否课程
    isCourseItem () {
      return this.isOfflineCourse || this.isOnlineCourse
    },
    // 判断是否线下课程
    isOfflineCourse () {
      return this.detailItem && this.detailItem.itemCategory && this.detailItem.itemCategory.categoryCode === '1031'
    },

    // 判断是否线上课程
    isOnlineCourse () {
      return (this.detailItem && this.detailItem.itemCategory && this.detailItem.itemCategory.parentList &&
        this.detailItem.itemCategory.parentList.length && this.detailItem.itemCategory.parentList[0].categoryCode === '1032') || (this.detailItem && this.detailItem.itemCategory &&
          (this.detailItem.itemCategory.categoryCode === '13003' || this.detailItem.itemCategory.categoryCode === '501'))
    },
    // 检查课程报名截止时间
    isCourseCutoff () {
      if (this.detailItem && this.detailItem.cutoffTime) {
        let cutoffTime = commonUtils.parseTime(new Date(this.detailItem.cutoffTime), '{y}-{m}-{d}')
        let curTime = commonUtils.parseTime(new Date(), '{y}-{m}-{d}')
        return cutoffTime < curTime
      }
      return false
    }
  },
  methods: {
    openElearning () {
      console.log(this.orderInfo, 'this.orderInfo')
      if (this.detailItem.itemCategoryCode === '501') {
        this.$emit('openElearning')
      } else {
        window.location.href = this.orderInfo.detailList[0].jumpLink
      }
    },
    orderCancel () {
      this.$emit('cancelOrder')
    },
    toSearchItem () {
      this.$emit('searchItem')
    }
  }
}
</script>
<style scoped lang="less">

.order-list {
  border: 1px solid #fff;
  background-color: #f1f1f1;
  display: flex;
  height: auto;
  font-size: 0.35rem;
  padding: 0.3rem;
  align-items: center;
  .order-item-img {
    width: 2.8rem;
    height: 2.8rem;
    flex-shrink: 0;
  }
  .order-item-content {
    min-height: 2.8rem;
    height: auto;
    flex: 1 1 auto;
    margin: 0 0.4rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .point-red {
    color: #e20015;

    span {
      font-size: 0.4rem;
    }
  }
  .from-group{
    flex: 1;
    margin: 0.2rem 0rem;
    font-size:0.3rem;
  }
}

.color-green {
  color: var(--base-green) !important;
}
.row{
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  .col-33{
    flex:0 0 33%;
  }
}
.margin-y-2 {
  margin: 0.2rem 0rem;
  z-index: 100;
}
.item-code{
  color: #999;
}
.font-600{
  font-weight: 600;
}
.cancel-order{
  padding:0.1rem;
  border:1px solid red;
}
.flex-end{
   align-items: flex-end !important;
}
</style>
